import { io, Socket } from 'socket.io-client';
import { API_BASE_URL } from './constants';

let socket: Socket | null = null;

export const getSocket = (): Socket => {
  if (!socket) {
    const token = localStorage.getItem('authToken');

    socket = io(API_BASE_URL, {
      path: '/socket',
      extraHeaders: {
        'X-Auth': token ?? '',
      },
      transports: ['polling', 'websocket'],
    });
  }

  return socket;
};

export const disconnectSocket = (): void => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
